var map = {
	"./Logo-sinfin-spread_spreadsuite-retail edition.svg": 1676,
	"./Logo-spread-suite_HUB.svg": 1677,
	"./assets/Shopify.png": 1678,
	"./assets/advent-calendar-logo.png": 1679,
	"./assets/borne_kiosk.png": 1680,
	"./assets/cloudcommerce.png": 1681,
	"./assets/cms.png": 1682,
	"./assets/facebook.png": 1683,
	"./assets/flipbook-pagetype-home.svg": 1684,
	"./assets/game-pagetype-alreadyplayed_game.svg": 1685,
	"./assets/game-pagetype-ended_game.svg": 1686,
	"./assets/game-pagetype-game_game.svg": 1687,
	"./assets/game-pagetype-home_game.svg": 1688,
	"./assets/game-pagetype-index_game.svg": 1689,
	"./assets/game-pagetype-login_game.svg": 1690,
	"./assets/game-pagetype-not_started_game.svg": 1691,
	"./assets/game-pagetype-results_loose_game.svg": 1692,
	"./assets/game-pagetype-results_win_game.svg": 1693,
	"./assets/gift_finder.png": 1694,
	"./assets/instagram.png": 1695,
	"./assets/instant-logo.png": 1696,
	"./assets/instore.png": 1697,
	"./assets/ipad_kiosk.png": 1698,
	"./assets/jeu.png": 1699,
	"./assets/magento.png": 1700,
	"./assets/marker.png": 1701,
	"./assets/minisite-pagetype-contact.svg": 1702,
	"./assets/minisite-pagetype-email_register.svg": 1703,
	"./assets/minisite-pagetype-flipbook.svg": 1704,
	"./assets/minisite-pagetype-home.svg": 1705,
	"./assets/minisite-pagetype-landing.svg": 1706,
	"./assets/minisite-pagetype-product_details.svg": 1707,
	"./assets/minisite-pagetype-register.svg": 1708,
	"./assets/minisite-pagetype-register_success.svg": 1709,
	"./assets/minisite-pagetype-wishlist.svg": 1710,
	"./assets/minisite.png": 1711,
	"./assets/online.png": 1712,
	"./assets/pinterest.png": 1713,
	"./assets/prestashop.png": 1714,
	"./assets/quizz-logo.png": 1715,
	"./assets/random-draw-logo.png": 1716,
	"./assets/rs.png": 1717,
	"./assets/store.png": 1718,
	"./assets/twitter.png": 1719,
	"./assets/woocommerce.png": 1720,
	"./assets/wordpress.png": 1721,
	"./avatar.png": 1722,
	"./banner.png": 1723,
	"./banner_video.png": 727,
	"./dashboard/dashboard_flux_de_travail.png": 431,
	"./dashboard/dashboard_prices.png": 728,
	"./ecran.png": 724,
	"./emptyCatalog.jpg": 279,
	"./emptyCompany.jpg": 216,
	"./image-fake-card.png": 67,
	"./image-fake.png": 319,
	"./image-home-dxp.png": 725,
	"./image-home-xl-test.png": 1724,
	"./image-home-xl.png": 726,
	"./john-doe.png": 229,
	"./lacoste.jpg": 1725,
	"./lacoste.svg": 1726,
	"./logo-sinfin-black.svg": 1727,
	"./logo-sinfin-digital.svg": 320,
	"./logo-sinfin-dxp.svg": 1728,
	"./logo-sinfin-new.svg": 1729,
	"./logo-spread-white.svg": 1730,
	"./logo-spread.svg": 1731,
	"./logo.png": 1732,
	"./logo_lego.svg": 1733,
	"./logo_sinfin.png": 1734,
	"./logotype-home.svg": 729,
	"./medias/Caisse.png": 730,
	"./medias/Citadium.png": 731,
	"./medias/Made-by-desgin.png": 732,
	"./medias/Nuxeo.png": 733,
	"./medias/Place-des-tendance.png": 734,
	"./medias/Printemps.png": 735,
	"./medias/admi-logo.png": 1735,
	"./medias/amazon-logo.png": 1736,
	"./medias/bestbuy-logo.png": 1737,
	"./medias/boulanger-logo.png": 1738,
	"./medias/brico_prive-logo.png": 1739,
	"./medias/brother-logo.png": 1740,
	"./medias/cdiscount-logo.png": 1741,
	"./medias/chronopost-logo.png": 1742,
	"./medias/cloudcommerce-logo.png": 1743,
	"./medias/colissimo-logo.png": 1744,
	"./medias/contentful-logo.png": 1745,
	"./medias/dropbox-logo.png": 1746,
	"./medias/drupal-logo.png": 1747,
	"./medias/ebay-logo.png": 1748,
	"./medias/facebook-logo.png": 1749,
	"./medias/farfetch-logo.png": 1750,
	"./medias/gdrive-logo.png": 1751,
	"./medias/google-shopping.png": 736,
	"./medias/googledrive-logo.png": 1752,
	"./medias/gshopping-logo.png": 1753,
	"./medias/instagram-logo.png": 1754,
	"./medias/laredoute-logo.png": 1755,
	"./medias/leboncoin-logo.png": 1756,
	"./medias/lengow-logo.png": 1757,
	"./medias/leroy_merlin-logo.png": 1758,
	"./medias/linkedin-logo.png": 1759,
	"./medias/magento-logo.png": 1760,
	"./medias/mailchimp-logo.png": 1761,
	"./medias/mailjet-logo.png": 1762,
	"./medias/manomano-logo.png": 1763,
	"./medias/mirakl-logo.png": 1764,
	"./medias/mondialrelay-logo.png": 1765,
	"./medias/onedrive-logo.png": 1766,
	"./medias/pinterest-logo.png": 1767,
	"./medias/pixelBackground.jpg": 417,
	"./medias/prestashop-logo.png": 1768,
	"./medias/rakuten-logo.png": 1769,
	"./medias/rdc-logo.png": 1770,
	"./medias/seloger-logo.png": 1771,
	"./medias/sendgrid-logo.png": 1772,
	"./medias/sendinblue-logo.png": 1773,
	"./medias/shopify-logo.png": 1774,
	"./medias/twitter-logo.png": 1775,
	"./medias/users/63d398aea0b42.png": 1776,
	"./medias/veepee-logo.png": 1777,
	"./medias/walmart-logo.png": 1778,
	"./medias/winrar.png": 1779,
	"./medias/woocommerce-logo.png": 1780,
	"./medias/wordpress-logo.png": 1781,
	"./medias/yoox-logo.png": 1782,
	"./medias/zalando-logo.png": 1783,
	"./minisite/Accueil.svg": 1784,
	"./minisite/Landing.svg": 1785,
	"./minisite/Produit.svg": 1786,
	"./minisite/Wishlist.svg": 1787,
	"./mirakl-logo-header.png": 1788,
	"./mirakl.png": 1789,
	"./not-found.png": 32,
	"./photo-home-notif.png": 1790,
	"./pictoVideo.svg": 515,
	"./retailers/Auchan.png": 194,
	"./retailers/Fcw.png": 1791,
	"./retailers/Lgr.png": 1792,
	"./sinfin-logo.svg": 718,
	"./socials/Calendar.png": 514,
	"./socials/Facebook.png": 1793,
	"./socials/Stats.png": 737,
	"./wiko-alpha.png": 1794,
	"./wiko.png": 1795
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 188;